import { ConsentManagementConfigVersion, ConsentModel } from "@/api";
import { summarizeTargets } from "./targeting";

export const ESSENTIAL_ALWAYS_SENT =
  "Destinations in the Essential category always receive events.";

export const MANAGED_REGIONS_OPT_IN =
  "Freshpaint’s built-in regional rules still ask for opt-in in the EU, UK and US privacy states.";

export function consentModelBehavior(model: ConsentModel): string {
  return model === "opt-in"
    ? "Freshpaint sends a visitor’s events to a destination only after they consent to its category."
    : "Freshpaint sends a visitor’s events to destinations right away, and stops sending to a category’s destinations once the visitor opts out of it.";
}

/** Describes what a version does, including rules that differ by site or region. */
export function versionBehavior(
  version: ConsentManagementConfigVersion,
): string {
  const models = new Set([
    version.consentModel,
    ...summarizeTargets(version)
      .filter((target) => !target.bannerOff)
      .map((target) => target.consentModel),
  ]);
  if (models.size > 1) {
    return "Under opt-in rules, Freshpaint sends a visitor’s events to a destination only after they consent to its category. Under opt-out rules, it sends them right away and stops once the visitor opts out of the category.";
  }
  return version.consentModel === "opt-out" &&
    version.freshpaintConfig?.geotargetingBehavior === "managed"
    ? `${consentModelBehavior("opt-out")} ${MANAGED_REGIONS_OPT_IN}`
    : consentModelBehavior(version.consentModel);
}
